import state from './state';
import actions from './actions';
import mutations from './mutations';
import * as getters from './getters';
import scene from './scene/store';


export default {
  namespaced: true,
  modules: {
    scene
  },
  state,
  actions,
  mutations,
  getters
};